module.exports = __webpack_public_path__ + "static/media/side1.04de1f8f.png";